export enum WorkplaceHighlightType {
  AM_PATIENTS_PER_WORKER = "am-patients-per-worker",
  NOC_PATIENTS_PER_WORKER = "noc-patients-per-worker",
  PM_PATIENTS_PER_WORKER = "pm-patients-per-worker",
  QUALIFICATION_PATIENTS_PER_WORKER = "qualification-patients-per-worker",
  CANCELLATION_PAYOUT = "cancellation-payout",
  CHARTING_SOFTWARE = "charting-software",
  DRESS_CODE = "dress-code",
  EXTRA_TIME_PAY = "extra-time-pay",
  BREAKS = "breaks",
  WELL_SUPPLIED = "well-supplied",
  INDEPENDENT_CONTRACTOR_BADGE_REQUIRED = "independent-contractor-badge-required",
  CANCELLATION_PROTECTION = "cancellation-protection",
  LATE_CLOCK_OUT = "late-clock-out",
  HIRING = "hiring",
}
